import { useState } from "react";
import { ShieldAlert, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function LoginGate() {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(password);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setError("Incorrect password — it's case-sensitive, check capitalization and the trailing character.");
        setPassword("");
      } else {
        setError(
          "The server is temporarily unreachable — nothing is wrong with your password. Wait a minute and press Unlock again."
        );
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-black flex items-center justify-center px-4">
      <div className="w-full max-w-md border-2 border-black bg-white p-8 md:p-10">
        <div className="flex items-center gap-3 border-b-2 border-black pb-5 mb-6">
          <div className="border-2 border-black p-2">
            <ShieldAlert className="w-5 h-5" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] opacity-70">
              Forensic Data Extractor
            </p>
            <h1 className="font-chivo text-xl md:text-2xl font-black tracking-tighter">
              Accident Report Triage
            </h1>
          </div>
        </div>

        <p className="font-mono text-[11px] uppercase tracking-[0.25em] opacity-70 mb-5">
          Restricted access — enter the team password to continue.
        </p>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label
              htmlFor="pw"
              className="font-mono text-[10px] uppercase tracking-[0.25em] block mb-1.5"
            >
              Password
            </label>
            <input
              id="pw"
              type="password"
              autoFocus
              autoComplete="current-password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-2 border-black bg-white px-3 py-2.5 font-mono text-sm outline-none focus:bg-zinc-50"
              placeholder="••••••••••••"
            />
          </div>

          {error && (
            <div
              data-testid="login-error"
              className="border border-red-600 bg-red-50 text-red-700 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.18em]"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="login-submit"
            disabled={busy || !password}
            className="w-full inline-flex items-center justify-center gap-2 border-2 border-black bg-black text-white px-4 py-3 font-mono text-[11px] uppercase tracking-[0.25em] font-bold hover:bg-zinc-800 disabled:opacity-50"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {busy ? "Verifying…" : "Unlock"}
          </button>
        </form>

        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] opacity-50 text-center">
          Session persists for 30 days on this browser.
        </p>
      </div>
    </div>
  );
}
